import type { Inbox } from "../../../api/content/reviewCollaborationApi";

/** What waits for the person to answer (ADR-0031 D4): to decide, sent back to them, knowledge data to review. */
export function waitingCount(inbox: Inbox): number {
  return inbox.waitingForMe.length + inbox.sentBackToMe.length + inbox.knowledgeData.waitingForMe.length;
}

/** The person's own open proposals, waiting on others. */
export function myOpenCount(inbox: Inbox): number {
  return inbox.myOpenProposals.length + inbox.knowledgeData.myProposals.length;
}
